import React, { useCallback, useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import { useTranslate } from "../../../../../Hooks";
import { useVerticalNav } from "../../../../../Contexts/VerticalNavContext";
import { GetAgentsForContactLeads } from "../../../../../Services";
import {
  AfterSalesAssignedAgentsCardsSkeleton,
  NoDataFound,
} from "../../../../../Components";
import AssignedAgentCard from "./AssignedAgentCard";

// styles
import useStyles from "./styles";

const AssignedAgentsPanel = ({ contactId }) => {
  const styles = useStyles();

  const { translate } = useTranslate("AfterSalesClientProfileView");
  const { setAlertBoxContent } = useVerticalNav();

  const [isLoading, setIsLoading] = useState(false);
  const [assignedAgents, setAssignedAgents] = useState({
    result: [],
    totalCount: 0,
  });
  const [pagination, setPagination] = useState({
    pageIndex: 1,
    pageSize: 25,
  });

  const fetchAssignedAgents = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await GetAgentsForContactLeads(
        contactId,
        pagination.pageIndex,
        pagination.pageSize
      );
      if (!(res && res.status && res.status !== 200)) {
        setAssignedAgents({
          result: res?.result || [],
          totalCount: res?.totalCount || 0,
        });
      }
    } catch (error) {
      setAssignedAgents({
        result: [],
        totalCount: 0,
      });
      setAlertBoxContent({
        display: true,
        variant: "error",
        message: translate("Something-went-wrong"),
        onclose: () => setAlertBoxContent(null),
      });
      console.error("Error fetching assigned agents:", error);
    } finally {
      setIsLoading(false);
    }
  }, [contactId]);

  useEffect(() => {
    fetchAssignedAgents();
  }, [pagination]);

  return (
    <Box className={styles.mainContainer}>
      {isLoading ? (
        <Box className={styles.skeletonContainer}>
          {Array.from({ length: 8 }, (_, index) => (
            <AfterSalesAssignedAgentsCardsSkeleton key={index} />
          ))}
        </Box>
      ) : assignedAgents?.result.length > 0 ? (
        <AssignedAgentCard items={assignedAgents?.result} />
      ) : (
        <NoDataFound title={translate("assigned-agents")} />
      )}
    </Box>
  );
};

export default AssignedAgentsPanel;
